<template>
    <div class="card">
        <div class="card-header bg-secondary">
            <!--
            <span>{{ index }}</span>
        -->
            {{ entrada.asiento.zona_nombre }} <br>
            <span v-if="entrada.asiento.fila && entrada.asiento.asiento">Fila: {{ entrada.asiento.fila }} / Butaca: {{ entrada.asiento.asiento }}</span>
            <span v-else>Sin numerar</span>
        </div>
        <div class="card-body">
            <template v-if="solicitar_datos">
                <FormInput label="Nombre" name="Nombre" v-model="entrada.nombre" @change="actualizado" />
                <FormInput label="Apellidos" name="Apellidos" v-model="entrada.apellidos" @change="actualizado" />
            </template>
            
            <div class="form-group">
                <label for="nombre">Precio</label>
                <select class="form-control" id="select-precio" v-model="entrada.precio" v-on:change="actualizado">
                    <template v-for="(precio, index) in entrada.precios">
                        <option :key="index" :value="precio">{{ precio.descripcion }} / {{ precio.gd_interno ? precio.precio : precio.precio + precio.price_management_taquilla | formatear_precio }}</option>
                    </template>
                </select>
            </div>
             <div class="form-group">
                    <label for="genero">Género</label>
                    <select class="form-control" id="select-genero" v-model="entrada.genero_id" v-on:change="actualizado">
                        <template v-for="genero in generos">
                            <option :key="genero.id" :value="genero.id">{{ genero.name }}</option>
                        </template>
                    </select>
                </div>
            <div class="form-group">
                <label for="metodo_pago">Descuento</label>
                <select v-model="entrada.descuento" class="form-control" id="descuento" v-on:change="actualizado">
                    <option value="0">Sin descuento</option>
                    <template v-for="(descuento, index) in configuracion.descuentos_disponibles">
                        <option :key="index" :value="descuento">{{ descuento }}%</option>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['entrada', 'generos', 'index', 'solicitar_datos'],
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            actualizado() {
                this.$emit('actualizado');
            },
        },
    }
</script>

<style>

</style>
